module.exports = {"apiUrl":"","publicPath":"/"};